import { useUploadCertificate } from '@/api/accounting-dealer'
import { FileInput } from '@/components'
import { toast } from '@/helpers'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

type CertificateUploadDialogProps = DialogProps & {
  companyKey: string
  onClose: () => void
}

export function CertificateUploadDialog({
  companyKey,
  onClose,
  open,
  ...props
}: CertificateUploadDialogProps) {
  const queryClient = useQueryClient()
  const [file, setFile] = useState<File | null>(null)
  const [password, setPassword] = useState('')

  const { mutate, isPending } = useUploadCertificate({
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['company', companyKey],
      })
      toast.success('Certificado digital cadastrado')
      onClose()
    },
  })

  useEffect(() => {
    if (!open) {
      setFile(null)
      setPassword('')
    }
  }, [open])

  const handleSubmit = () => {
    if (!file || !password) return

    const body = new FormData()
    body.append('file', file)
    body.append('password', password)

    mutate({ companyKey, body })
  }

  return (
    <Dialog
      {...props}
      open={open}
      onClose={isPending ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Cadastrar certificado digital</DialogTitle>
      <DialogContent>
        <FileInput
          id="certificate-file"
          value={file}
          onChange={setFile}
          placeholder="Selecione um arquivo (.pfx ou .p12)"
          inputProps={{ accept: '.pfx,.p12,application/x-pkcs12' }}
          disabled={isPending}
        />
        <TextField
          label="Senha"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          fullWidth
          margin="normal"
          disabled={isPending}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          loading={isPending}
          disabled={!file || !password}
          onClick={handleSubmit}
        >
          Cadastrar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
